<template>
  <div class="page-wrapper">
    <v-layout align-center>
      <v-flex xs12 sm10 md8 lg8>
        <form v-scroll-to-error @submit.prevent="submitForm">
          <v-layout wrap>
            <v-flex xs12>
              <div v-if="$apollo.loading">
                <spinner />
              </div>
              <div v-else>
                <div class="title-screen">
                  <span>{{ adminText('workflowsAll.event_conference_info_0f6852d', 'Event conference info') }}</span>
                </div>
                <conference-data-form :initial-values="form" :vs="$v" @values="form = $event" />
                <v-layout justify-end>
                  <main-button :text="adminText('workflowsAll.update_fb91e24', 'Update')" depressed @click="$emit('submit')" />
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
      <simple-snackbar
        :open.sync="snackbar"
        color="primary"
        :message-prop="adminText('workflowsAll.conference_details_saved_f6fba16', 'Conference details saved')"
      />
    </v-layout>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { required } from 'vuelidate/lib/validators'

import {
  GET_EVENT_CONFERENCE_DATA,
  UPDATE_EVENT_CONFERENCE_DATA,
} from '../../graphql/event.graphql'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar'
import ConferenceDataForm from './event-conference-data-form'
import { DEFAULT_HUE, getBrandColor } from '@/utils/color'
import { submitGuard } from '../../utils'

// The design's default brand colour, #ff8875 - also what the hue picker falls back to.
const DEFAULT_PRIMARY_COLOR = getBrandColor(DEFAULT_HUE)

export default {
  mixins: [WorkflowDisplay],
  name: 'event-conference-data-container',
  components: { ConferenceDataForm, SimpleSnackbar },
  props: {
    eventId: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        welcomeTitle: { required },
        welcomeSubtitle: { required },
      },
    }
  },
  data() {
    return {
      form: {
        primaryColor: DEFAULT_PRIMARY_COLOR,
      },
      snackbar: false,
    }
  },
  methods: {
    async submitForm() {
      await submitGuard(this, async () => {
        const { id, __typename, ...input } = this.form

        await this.$apollo.mutate({
          mutation: UPDATE_EVENT_CONFERENCE_DATA,
          variables: {
            eventId: this.eventId,
            input,
          },
        })
        this.snackbar = true
      })
    },
  },
  apollo: {
    getEventConferenceData: {
      query: GET_EVENT_CONFERENCE_DATA,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ data: { getEventConferenceData: conferenceData }, loading }) {
        if (!loading) {
          if (!conferenceData) return
          const { primaryColor, ...rest } = conferenceData

          this.form = {
            primaryColor: primaryColor || DEFAULT_PRIMARY_COLOR,
            ...rest,
          }
        }
      },
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .page-wrapper {
    margin-top: 1.5rem;
  }
}
</style>
